var _rect, _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 189,
    viewBox: "0 0 221 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 78.0178,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1508_31073)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 47.3227C105.039 45.8193 110.247 45.7821 115.14 47.2157L201.676 72.5645C207.399 74.241 207.437 82.3351 201.729 84.0647L115.378 110.232C110.337 111.759 104.95 111.72 99.9323 110.118L18.214 84.0381C12.618 82.2521 12.6564 74.3204 18.2695 72.5888L100.166 47.3227Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1508_31073)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 76.0178,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.874 2.53345C103.181 2.53345 91.2695 14.4453 91.2695 29.1382C91.2695 43.8311 103.181 55.743 117.874 55.743C132.567 55.743 144.479 43.8311 144.479 29.1382C144.479 14.4453 132.567 2.53345 117.874 2.53345ZM126.743 27.3646C122.823 27.3646 119.648 24.1897 119.648 20.27C119.648 16.3502 122.823 13.1753 126.743 13.1753C130.662 13.1753 133.837 16.3502 133.837 20.27C133.837 24.1897 130.662 27.3646 126.743 27.3646Z",
    fill: "#4671F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.352 39.4714L74.5726 58.2508C73.9057 58.9177 73.5332 59.8187 73.5332 60.7588V69.9321C73.5332 71.8902 75.1224 73.4794 77.0805 73.4794H86.2538C87.1939 73.4794 88.0984 73.1069 88.7618 72.44L93.3484 67.8534C94.2885 66.9133 94.817 65.6363 94.817 64.3061C94.817 61.5356 97.0624 59.2902 99.8329 59.2902C101.163 59.2902 102.44 58.7617 103.38 57.8216L107.541 53.6606C101.156 50.9682 96.0444 45.853 93.352 39.4714Z",
    fill: "#A4BCFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1508_31073",
    x: 69,
    y: 60.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1508_31073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1508_31073",
    x1: 206,
    y1: 133.018,
    x2: 14,
    y2: 133.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.350d2504fd3ca797e1128341eb69cdb9.svg";
export { ForwardRef as ReactComponent };